<div [ngClass]="selectStyle" class="base-select-wrapper">
    <mat-form-field appearance="outline" [class.infix-nolabel]="!label">
        @if (!!label) {
        <mat-label>{{ label }}</mat-label>
        }
        <mat-select [disabled]="disabled" [required]="required" [(ngModel)]="model" (ngModelChange)="updateNewValue($event)" porAddFeature [featureName]="featureName">
            @for (option of options; track option) {
            <mat-option [value]="option.value">
                {{ option.label }}
            </mat-option>
            }
        </mat-select>
        <mat-icon matIconSuffix>keyboard_arrow_down</mat-icon>
        @if (formField?.hasError('required')) {
        <mat-error>required*</mat-error>
        }
    </mat-form-field>
</div>
